import React from "react";
import { NavLink, useNavigate, Outlet } from "react-router-dom";
import {
  LayoutDashboard,
  ShoppingBag,
  Package,
  LogOut,
  ExternalLink,
  Menu,
  X,
} from "lucide-react";
import { adminAuth } from "../../services/adminApi";

const NAV = [
  { to: "/admin/dashboard", label: "Resumen", icon: LayoutDashboard },
  { to: "/admin/orders", label: "Pedidos", icon: ShoppingBag },
  { to: "/admin/products", label: "Productos", icon: Package },
];

export default function AdminLayout() {
  const navigate = useNavigate();
  const [mobileOpen, setMobileOpen] = React.useState(false);

  const handleLogout = () => {
    adminAuth.logout();
    navigate("/admin");
  };

  return (
    <div className="min-h-screen bg-stone-50 flex">
      {/* Mobile toggle */}
      <button
        onClick={() => setMobileOpen(!mobileOpen)}
        className="lg:hidden fixed top-4 left-4 z-50 bg-white p-2 rounded-lg shadow-lg border border-stone-200"
        data-testid="admin-mobile-toggle"
      >
        {mobileOpen ? <X className="w-5 h-5" /> : <Menu className="w-5 h-5" />}
      </button>

      {/* Sidebar */}
      <aside
        className={`
          fixed lg:sticky top-0 left-0 z-40 h-screen w-64 bg-white border-r border-stone-200
          transform transition-transform duration-300 ease-in-out
          ${mobileOpen ? "translate-x-0" : "-translate-x-full lg:translate-x-0"}
        `}
      >
        <div className="flex flex-col h-full">
          {/* Logo */}
          <div className="p-6 border-b border-stone-100">
            <div className="flex items-center gap-3">
              <div className="w-10 h-10 bg-amber-700 rounded-xl flex items-center justify-center">
                <span className="text-white font-bold">B</span>
              </div>
              <div>
                <h2 className="font-bold text-stone-800 leading-tight">
                  Burbujas
                </h2>
                <p className="text-xs text-stone-500">Panel admin</p>
              </div>
            </div>
          </div>

          {/* Nav */}
          <nav className="flex-1 px-4 py-6 space-y-1">
            {NAV.map(({ to, label, icon: Icon }) => (
              <NavLink
                key={to}
                to={to}
                onClick={() => setMobileOpen(false)}
                className={({ isActive }) =>
                  `flex items-center gap-3 px-4 py-2.5 rounded-xl text-sm font-medium transition-colors ${
                    isActive
                      ? "bg-amber-100 text-amber-900"
                      : "text-stone-600 hover:bg-stone-100"
                  }`
                }
                data-testid={`admin-nav-${label.toLowerCase()}`}
              >
                <Icon className="w-4 h-4" />
                {label}
              </NavLink>
            ))}
          </nav>

          {/* Footer */}
          <div className="p-4 border-t border-stone-100 space-y-2">
            <a
              href="/"
              target="_blank"
              rel="noreferrer"
              className="flex items-center gap-3 px-4 py-2.5 rounded-xl text-sm text-stone-600 hover:bg-stone-100"
            >
              <ExternalLink className="w-4 h-4" />
              Ver tienda
            </a>
            <button
              onClick={handleLogout}
              className="w-full flex items-center gap-3 px-4 py-2.5 rounded-xl text-sm text-red-600 hover:bg-red-50"
              data-testid="admin-logout-btn"
            >
              <LogOut className="w-4 h-4" />
              Cerrar sesión
            </button>
          </div>
        </div>
      </aside>

      {/* Main */}
      <main className="flex-1 lg:ml-0 min-h-screen">
        <Outlet />
      </main>

      {/* Mobile overlay */}
      {mobileOpen && (
        <div
          className="lg:hidden fixed inset-0 bg-black/30 z-30"
          onClick={() => setMobileOpen(false)}
        />
      )}
    </div>
  );
}
